// ignore-string-externalization

/* stylelint-disable font-family-no-missing-generic-family-keyword */

import { css } from 'styled-components';
import {
  goldHighlight,
  btnFontSizeLg,
  btnPaddingLargeVertical,
  btnPaddingLargeHorizontal,
} from './variables';

/**
 * CSS to contain a float (credit to CSSMojo).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...clearFix(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${clearFix()}
 * `
 *
 * // CSS as JS Output
 *
 * '&::after': {
 *   'clear': 'both',
 *   'content': '""',
 *   'display': 'table'
 * }
 */

export const clearFix = (parent = '&') => {
  const pseudoSelector = `${parent}::after`;
  return {
    [pseudoSelector]: {
      clear: 'both',
      content: '""',
      display: 'table',
    },
  };
};

export const textHide = css`
  font: 0/0 a;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  border: 0;
`;

export const square = (size: $TSFixMe) => css`
  width: ${size};
  height: ${size};
`;

export const imgCircle = css`
  border-radius: 50%;
`;

// External arrow
export const iconExternalLink = (strokeColor = goldHighlight) => css`
  background-image: url('data:image/svg+xml;utf8,<svg width="10" height="10" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg"><title>Arrow</title><g stroke="${strokeColor}" stroke-width="2" fill="none" fill-rule="evenodd"><path d="M1 9l8-8"/><path stroke-linejoin="round" d="M2 .998h7V8"/></g></svg>');
`;

export const btnLg = () => css`
  padding: ${parseInt(btnPaddingLargeVertical, 10) +
    Math.floor(parseInt(btnFontSizeLg, 10) / 12)}px
    ${btnPaddingLargeHorizontal}
    ${parseInt(btnPaddingLargeVertical, 10) -
    Math.floor(parseInt(btnFontSizeLg, 10) / 12)}px;
`;
